import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function ThumbsDown({ width, height, color }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.34457 11.7983L9.57041 8.56667C9.78624 8.35083 9.90874 8.05333 9.90874 7.74417V1.91667C9.90874 1.275 9.38374 0.75 8.74207 0.75H3.49791C3.03124 0.75 2.61124 1.03 2.43041 1.45583L0.52874 5.895C0.0329069 7.05 0.87874 8.33333 2.13291 8.33333H5.42874L4.87457 11.005C4.81624 11.2967 4.90374 11.5942 5.11374 11.8042C5.45791 12.1425 6.00624 12.1425 6.34457 11.7983ZM12.2479 0.75C11.6062 0.75 11.0812 1.275 11.0812 1.91667V6.58333C11.0812 7.225 11.6062 7.75 12.2479 7.75C12.8896 7.75 13.4146 7.225 13.4146 6.58333V1.91667C13.4146 1.275 12.8896 0.75 12.2479 0.75Z'
        fill={color || theme.colors.gray500}
      />
    </svg>
  );
}
